import PythonApi from '@/services/PythonApi'

export default {
  list(withCompany = false) {
    const params = new URLSearchParams()

    if (withCompany)
      params.append('with_company', 'true')

    return PythonApi().get('users', params)
  },
  show(userID) {
    return PythonApi().get(`users/${userID}`)
  },
  post(user) {
    return PythonApi().post('users', user)
  },
  put(user) {
    return PythonApi().put(`users/${user.id}`, user)
  },
  delete(userID) {
    return PythonApi().delete(`users/${userID}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/UsersService.js